function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.832 12.64l-4.062.344a.32.32 0 01-.337-.381L20.803.384c.062-.32-.333-.519-.548-.275L6.081 16.199c-.19.217-.022.558.263.534l4.063-.344a.32.32 0 01.338.382L8.375 28.99c-.063.32.333.52.548.276l14.173-16.09c.19-.216.022-.558-.264-.534z",
  fill: "currentColor"
})));